import React, {useCallback} from 'react';
import {twMerge} from 'tailwind-merge';

import ColorPicker from '../../../../components/ColorPicker';
import {SettingLabel} from '../components/SettingLabel';
import {SemanticLegendSettings} from '../types';
import {DEFAULT_SEMANTIC_LEGEND_SETTINGS} from './SemanticLegendDefaults';

export type SemanticLegendExcludedRunColorProps = {
  excludedRunColor: string;
  updateSetting: (settings: Partial<SemanticLegendSettings>) => void;
};

export const SemanticLegendExcludedRunColor = ({
  updateSetting,
  excludedRunColor,
}: SemanticLegendExcludedRunColorProps) => {
  const updateSettingValue = useCallback(
    (newVal?: string) => {
      updateSetting({
        excludedRunColor:
          newVal || DEFAULT_SEMANTIC_LEGEND_SETTINGS.excludedRunColor,
      });
    },
    [updateSetting]
  );
  return (
    <div
      className={twMerge('flex w-full', 'items-center', 'gap-20 py-16')}
      data-test="excluded-run-color-setting">
      <SettingLabel text="Excluded run color" className="min-w-fit" />
      <ColorPicker
        activeColor={excludedRunColor}
        setColor={updateSettingValue}
        trigger="button"
      />
    </div>
  );
};
